import React, { useEffect, useState } from "react";
import "./Dashboard.css";
import Sidebar from "./Sidebar/Sidebar";
import { Outlet } from "react-router-dom";
import { useAuth } from "./../../provider/authProvider";
import CodeQueueSpinner from "../../Utils";
import { getRole } from "../../DecodeToken/DecodeToken";

const Dashboard = () => {
  const { token } = useAuth();
  const [role, setRole] = useState(null);

  useEffect(() => {
    document.title = "Codequeue - Dashboard";
  }, []);

  useEffect(() => {
    const fetchRole = async () => {
      if (token) {
        const userRole = await getRole();
        setRole(userRole);
      }
    };
    fetchRole();
  }, [token, role]);

  return (
    <div>
      {!role ? (
        <div className="h-[500px] flex justify-center items-center">
          <CodeQueueSpinner />
        </div>
      ) : (
        <div className="dashboard">
          <Sidebar />
          <main className="main-content">
            <Outlet />
          </main>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
